import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    header: {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: 'white',
    },
});
